var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fragment',[_c('UploadContainer',{attrs:{"type":'C',"uploadBtnText":_vm.$locale('global.uploadPDF'),"action":"/api/cinema/uploadPdf","accept":'.pdf'},on:{"onSuccess":function (ref) {
	var response = ref.response;

	return _vm.uploadPDFSuccess(response);
}}}),_c('el-button',{staticClass:"egl-btn-yellow",staticStyle:{"margin-right":"10px"},on:{"click":_vm.dlPDF}},[_vm._v("ダウンロード")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }